import Debug from 'debug'
import Region from './Region.js'

const debug = Debug('cbio.regions')

export default (api) => ({
  closest: async (query, options) => {
    debug('closest()')
    return new Region(api, await api.fetch(Region.url({ id: 'closest' }), query, options))
  }
})

export { Region }
